<template>
	<div class="app-checkbox">
		<label class="app-checkbox__item">
			<input
				class="app-checkbox__core"
				type="checkbox"
				:disabled="props.disabled"
				:name="props.text"
				:checked="value === valueOn"
				@input="onInput"
			/>
			<div
				v-if="props.shape === 'square'"
				:class="{
					'app-checkbox__item-label': true,
					[`app-checkbox__item-label__${props.size}`]: true,
					'app-checkbox__item-label__disabled':props.disabled,
					// 'app-checkbox__item-label__disabled-checked':props.disabled && props.value,
				}"
			/>
			<AppIcon
				v-else
				:name="isChecked ? 'checked-round' : 'unchecked-round'"
				size="16px"
				:class="{
					'app-checkbox__item-round': true,
					'app-checkbox__item-round__disabled': props.disabled,
				}"
			/>
			<span
				v-if="text"
				:class="{
					'app-checkbox__item-text': true,
					[`app-checkbox__item-text__${props.size}`]: true,
				}"
			>
				{{ props.text }}
			</span>
		</label>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

type checkboxProps = {
	disabled?: boolean;
	size?: "md";
	shape?: "square" | "round";
	text?: string;
	value?: boolean;
	valueOn?: boolean;
	valueOff?: boolean;
};

type checkboxEmit = {
	"on-change": [event: object];
	"on-input": [value: boolean];
	"update:value": [value: boolean];
	input: [value: boolean];
};

const props = withDefaults(defineProps<checkboxProps>(), {
	size: "md",
	shape: "square",
	text: "",
	value: false,
	valueOff: false,
	valueOn: true,
});

const emit = defineEmits<checkboxEmit>();

const isChecked = computed(() => props.value === props.valueOn);

const onInput = (event: Event) => {
	if (!event.target) return undefined;
	const target = event.target as HTMLInputElement;
	const value = target.checked ? props.valueOn : props.valueOff;
	emit("on-change", event);
	emit("on-input", value);
	emit("update:value", value);
	emit("input", value);
};
</script>

<style lang="scss" scoped>
@import '@/styles/color.scss';

.app-checkbox {
	height: 17px;
	
	&__core {
		height: 0;
		opacity: 0;
		pointer-events: none;
		position: absolute;
		width: 0;
	}

	&__core:checked ~ .app-checkbox__item-label {
		background-color: $background-white;
		border: 1px solid $color-accent;
		background-image: url("@/assets/image/check.svg");
		background-repeat: no-repeat;
		background-position: center;
		background-size: 12px 10px;
		&:hover {
			background-color: $background-card;
			// border: 1px solid $indigo-600;
		}
		// &:active {
		// 	background-color: $indigo-700;
		// 	border: 1px solid $indigo-700;
		// }
		// &__disabled-checked {
		// 	border: 1px solid $zinc-600;
		// 	background-color: $zinc-600;
		// 	background-image: url("@/assets/image/check.svg");
		// 	cursor: default;
		// 	&:hover {
		// 		border: 1px solid $zinc-600;
		// 		background-color: $zinc-600;
		// 	}
		// 	&:active {
		// 		border: 1px solid $zinc-600;
		// 		background-color: $zinc-600;
		// 	}
		// }
	}

	&__item {
		display: inline-flex;
		flex-direction: row;
		justify-content: flex-start;
		position: relative;
		cursor: pointer;
	}

	&__item-label {
		border: 1px solid $color-border;
		border-radius: 4px;
		// transition: all 0.3s ease;
		&__md {
			height: 16px;
			width: 16px;
		}
		// &__lg {
		// 	height: 24px;
		// 	width: 24px;
		// }
		&:hover {
			border: 1px solid $color-border;
			background-color: $color-divider;
		}
		// &:active {
		// 	border: 1px solid $color-accent;
		// }
		&__disabled {
			cursor: default;
			border: 1px solid $color-divider;
			background-color: $border-color !important;
			opacity: 0.43;
			&:hover {
				border: 1px solid $color-divider;
				background-color: $background-white;
			}
			// &:active {
			// 	border: 1px solid $zinc-400;
			// }
		}
		// &__disabled-checked {
		// 	border: 1px solid $zinc-600;
		// 	background-color: $zinc-600;
		// 	background-image: url("@/assets/image/check.svg");
		// 	cursor: default;
		// 	&:hover {
		// 		border: 1px solid $zinc-600;
		// 		background-color: $zinc-600;
		// 	}
		// 	&:active {
		// 		border: 1px solid $zinc-600;
		// 		background-color: $zinc-600;
		// 	}
		// }
	}
	&__item-round {
		display: inline-flex;
		align-items: center;
		line-height: 0;
		&__disabled {
			cursor: default;
			opacity: 0.43;
		}
	}
	&__item-text {
		box-sizing: content-box;
		vertical-align: middle;
		padding-left: 8px;
		user-select: none;
		font-family: 'Roboto';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		color: $color-text_main;
		&__md {
			font-size: 18px;
			line-height: 17px;
		}
		// &__lg {
		// 	font-size: 24px;
		// 	line-height: 24px;
		// }
	}
}
</style>
